import 'css/components/auth-backdrop.css'

/**
 * The mockup's decorative `.lava` layer on the auth screens -- four large,
 * heavily blurred colour blooms behind the login/sign-up card. Purely
 * decorative, so it is aria-hidden and does not take pointer events.
 *
 * The mockup defines drift animations for the blobs but then overrides them
 * with `.lava .blob { animation: none }`, i.e. it ships static. Matched here,
 * which also keeps it free of continuous compositing on a login screen.
 */
export const AuthBackdrop = () => (
	<div className="auth-lava" aria-hidden="true">
		<span className="auth-blob auth-blob-1" />
		<span className="auth-blob auth-blob-2" />
		<span className="auth-blob auth-blob-3" />
		<span className="auth-blob auth-blob-4" />
	</div>
)
